import React, { useState } from "react";

const TermsAndConditions = () => {
  const [accepted, setAccepted] = useState(false);

  return (
    <div className="max-w-4xl mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Terms and Conditions</h1>
      <p className="mb-4">Last Updated: February 12, 2025</p>

      <section className="mb-6">
        <h2 className="text-xl font-semibold">1. Introduction</h2>
        <p>Welcome to Eeezo Connect. By accessing or using our services, you agree to comply with these Terms and Conditions.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold">2. User Responsibilities</h2>
        <ul className="list-disc pl-5">
          <li>Users must provide accurate information during registration.</li>
          <li>You are responsible for maintaining the confidentiality of your account.</li>
          <li>Unauthorized use of our services is strictly prohibited.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold">3. Prohibited Activities</h2>
        <p>Users must not:</p>
        <ul className="list-disc pl-5">
          <li>Engage in illegal or fraudulent activities.</li>
          <li>Attempt to disrupt or hack our platform.</li>
          <li>Share misleading or harmful content.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold">4. Termination</h2>
        <p>We reserve the right to terminate accounts that violate our terms or policies without prior notice.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold">5. Limitation of Liability</h2>
        <p>We are not liable for any damages resulting from the use or inability to use our services.</p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold">6. Updates to Terms</h2>
        <p>We may update these terms from time to time. Continued use of our services after changes means you accept the new terms.</p>
      </section>

      <div className="mt-6 flex items-center">
        <input
          type="checkbox"
          id="acceptTerms"
          checked={accepted}
          onChange={() => setAccepted(!accepted)}
          className="mr-2"
        />
        <label htmlFor="acceptTerms">I agree to the Terms and Conditions</label>
      </div>

      <button
        className={`mt-4 px-6 py-2 text-white rounded ${
          accepted ? "bg-blue-600 hover:bg-blue-700" : "bg-gray-400 cursor-not-allowed"
        }`}
        disabled={!accepted}
      >
        Proceed
      </button>
    </div>
  );
};

export default TermsAndConditions;

